import {
  HiOutlineClipboardList,
  HiOutlineDocumentText,
  HiOutlineFolderOpen,
  HiOutlineHome
} from 'react-icons/hi';
import { MenuItem } from '.';
import { pathnames } from 'routes/lcms';

const lcmsMenu: MenuItem[] = [
  {
    name: 'Overview',
    url: pathnames.overview,
    icon: HiOutlineHome,
    children: [],
    role: ['superadmin']
  },
  {
    name: 'Courses',
    url: pathnames.courses,
    icon: HiOutlineDocumentText,
    children: [],
    role: ['superadmin']
  },
  {
    name: 'Course TNA',
    url: pathnames.courseCombineTNA,
    icon: HiOutlineFolderOpen,
    children: [],
    role: ['superadmin']
  },
  {
    name: 'Course Planning',
    url: pathnames.coursePlan,
    icon: HiOutlineClipboardList,
    children: [],
    role: ['superadmin']
  }
];

export const LCMS_MENU = lcmsMenu;
